import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import Vue from 'vue';
import firebase from 'firebase/app';
import {firestorePlugin} from 'vuefire';

const firebaseConfig = {
  apiKey: 'AIzaSyAru_BQ0gmoyso5ktBZhpCoylh0KPN7ldw',
  authDomain: 'chef-naturelle.firebaseapp.com',
  databaseURL: 'https://chef-naturelle.firebaseio.com',
  projectId: 'chef-naturelle',
  storageBucket: 'chef-naturelle.appspot.com',
  messagingSenderId: '722775076748',
  appId: '1:722775076748:web:961437f741ca5d43'
};

Vue.use(firestorePlugin);

export const app = firebase.initializeApp(firebaseConfig);
export const db = app.firestore();
export const storage = app.storage();
export const Timestamp = firebase.firestore.Timestamp;
